var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid d-flex flex-column flex-grow-1 mt-3"},[_c('ListingComponent',{staticClass:"bg-white",attrs:{"showChatIdFilter":true,"requestProvider":_vm.requestProvider,"columnConfig":_vm.columnConfig}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c615a70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quiz/QuizUserTriesListPage.vue
// module id = null
// module chunks = 